module.exports = __webpack_public_path__ + "static/google-play-8ffd93c7c9842aaee1fdf52d891a0611.png";